import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import {
  BookRequestPayloadType,
  BookRequestPagination,
  BookRequestData,
  BookRequestDetailResponse,
  ApiBookRequest,
} from "../types/bookRequestTypes";

export const bookRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookRequests: builder.query<
      ApiResponseType<BookRequestData>,
      BookRequestPagination
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.status) queryParams.append("status", params.status);
        if (params?.course) queryParams.append("course", params.course);
        if (params?.stage) queryParams.append("stage", params.stage);
        if (params?.student_id)
          queryParams.append("student_id", params.student_id.toString());

        return `book-requests/get-all?${queryParams.toString()}`;
      },
      providesTags: ["BookRequests"],
    }),
    getBookRequestById: builder.query<
      ApiResponseType<BookRequestDetailResponse>,
      { id: string | number }
    >({
      query: ({ id }) => `book-requests/get/${id}`,
      providesTags: (result, error, { id }) => [
        { type: "BookRequests", id },
        "BookRequests",
      ],
    }),
    saveBookRequest: builder.mutation<
      ApiResponseType<{ bookrequest: ApiBookRequest }>,
      BookRequestPayloadType
    >({
      query: (payload) => ({
        url: "book-requests/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["BookRequests"],
    }),
    updateBookRequestStatus: builder.mutation<
      ApiResponseType<{ bookrequest: ApiBookRequest }>,
      { id: number; status: string; reviewerNote?: string }
    >({
      query: ({ id, status, reviewerNote }) => ({
        url: `book-requests/update-status/${id}`,
        method: "PUT",
        body: { status, reviewer_note: reviewerNote },
      }),
      invalidatesTags: ["BookRequests"],
    }),
    deleteBookRequest: builder.mutation<ApiResponseType<void>, { id: number }>({
      query: ({ id }) => ({
        url: `book-requests/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BookRequests"],
    }),
    reviewBookRequest: builder.mutation<
      ApiResponseType<{ bookrequest: ApiBookRequest }>,
      { id: number; status: string; reviewer_note?: string }
    >({
      query: ({ id, status, reviewer_note }) => ({
        url: `book-requests/review/${id}`,
        method: "PUT",
        body: { status, reviewer_note },
      }),
      invalidatesTags: ["BookRequests"],
    }),
  }),
});

export const {
  useGetBookRequestsQuery,
  useGetBookRequestByIdQuery,
  useSaveBookRequestMutation,
  useUpdateBookRequestStatusMutation,
  useDeleteBookRequestMutation,
  useReviewBookRequestMutation,
} = bookRequestApi;
